import _ from 'lodash';
import { useAppDispatch, useAppSelector } from './redux';
import { useCallback } from 'react';
import AuthActions from '../redux/auth/action';
import { IUser } from '../models/user.model';

export function useUser() {
  return useAppSelector((state) => state.auth.user);
}

export function useSetUser() {
  const dispatch = useAppDispatch();
  return useCallback(
    (payload?: IUser | null | undefined) => {
      return dispatch(AuthActions.setUser(payload));
    },
    [dispatch],
  );
}
